const Linkedin = () => {
  return (
    <svg
      width="41"
      height="40"
      viewBox="0 0 41 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.012207" width="40.2832" height="40" rx="10" fill="white" />
      <path
        d="M24.1821 16C25.7847 16 27.3216 16.6321 28.4548 17.7574C29.588 18.8826 30.2246 20.4087 30.2246 22V29H26.1963V22C26.1963 21.4696 25.9841 20.9609 25.6064 20.5858C25.2286 20.2107 24.7163 20 24.1821 20C23.6479 20 23.1356 20.2107 22.7579 20.5858C22.3802 20.9609 22.168 21.4696 22.168 22V29H18.1396V22C18.1396 20.4087 18.7763 18.8826 19.9095 17.7574C21.0426 16.6321 22.5796 16 24.1821 16V16Z"
        stroke="#181919"
        stroke-width="1.03293"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.1113 17H10.083V29H14.1113V17Z"
        stroke="#181919"
        stroke-width="1.03293"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.0972 14C13.2096 14 14.1113 13.1046 14.1113 12C14.1113 10.8954 13.2096 10 12.0972 10C10.9848 10 10.083 10.8954 10.083 12C10.083 13.1046 10.9848 14 12.0972 14Z"
        stroke="#181919"
        stroke-width="1.03293"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export default Linkedin
